module.exports = __webpack_public_path__ + "static/media/sdg_icon_4.03dd5c49.png";